import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    .container {
        width: 100%;
        justify-content: center;
        min-height: 800px;
    }

    ds-place-list-editor {
        width: 400px;
    }
`;
